export default __webpack_public_path__ + "static/media/GermanyFlag.72c7c18a.png";